import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DialogService } from 'src/app/utils/dialog.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { CererePriorityService } from './cerere-priority.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { AddCererePriorityComponent } from './add-cerere-priority/add-cerere-priority.component';
import Swal from 'sweetalert2';
import { EditCererePriorityComponent } from './edit-cerere-priority/edit-cerere-priority.component';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
    selector: "app-cerere-priority",
    templateUrl: "./cerere-priority.component.html",
    styleUrls: ["./cerere-priority.component.scss"],
})
export class CererePriorityComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    showCard = false;
    activeValue: string = "-1";
    publicValue: string = "-1";

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink =
        environment.interop.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.cererePriority
            .getCererePrioritiesDT;

    parameters: { key: string; value: string }[] = [
        { key: "--Alegeți--", value: "-1" },
        { key: "Da", value: "1" },
        { key: "Nu", value: "0" },
    ];

    resetForm() {
        this.activeValue = "-1";
        this.publicValue = "-1";

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }
    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private cererePriorityService: CererePriorityService,
        public permissionsService: PermissionsService
    ) {

    }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next("");
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            responsive: true,
            searching: false,
            pageLength: 25,
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.active = this.activeValue;
                dataTablesParameters.public = this.publicValue;
                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: "ID",
                    data: "id",
                },
                {
                    title: "Prioritate",
                    data: "name",
                    render: (data: any, type: any, row: any) => {
                        const bgColor = row.bg_color || "";
                        return `<span style="background-color: ${bgColor}; color: white; border-radius: 4px; padding: 3px 10px">${data}</span>`;
                    },
                },

                {
                    title: "Timp (minute)",
                    data: "time",
                    render: (data: any) => {
                        return `<div>${data}</div>`;
                    },
                },
                {
                    title: "Acțiuni",
                    data: null,
                    orderable: false,
                    className: "all",
                    render: (data: any, type: any, row: any, met: any) => {
                        return (
                            `
                            <div class=" d-flex gap-1">
                                <button class="action-btn edit" title="Editează">
                                    <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
                                </button>
                                <button class="action-btn delete" title="Șterge">
                                    <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/
                                </button>
                                <button title="Activează" type="button" class="action-btn update_status_active ` +
                            (row.active == true ? "action-success" : "action-danger") +
                            `">
                                    <img class="btn-img" src="` +
                            (row.active == true
                                ? "/assets/icons/check-white.svg"
                                : "/assets/icons/close-white.svg") +
                            `" alt="update_status_active"/>
                                </button>
                                <button title="Updatează Status" type="button" class="action-btn update_status_public ` +
                            (row.public_visible == true
                                ? "action-success"
                                : "action-danger") +
                            `">
                                    <img class="btn-img" src="` +
                            (row.public_visible == true
                                ? "/assets/icons/public_white.svg"
                                : "/assets/icons/public_not_white.svg") +
                            `" alt="update_status_public"/>
                                </button>
                            </div>
              `
                        );
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector("td:last-child");
                const editIcon = lastTd?.querySelector(".edit") as HTMLElement;
                const deleteIcon = lastTd?.querySelector(".delete") as HTMLElement;
                const updateStatusActiveIcon = lastTd?.querySelector(
                    ".update_status_active"
                ) as HTMLElement;
                const updateStatusPublicIcon = lastTd?.querySelector(
                    ".update_status_public"
                ) as HTMLElement;

                if (editIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'autcom-module.settings.prioritati-cerere.update'
                        )
                    ) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener("click", () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'autcom-module.settings.prioritati-cerere.delete'
                        )
                    ) {
                        deleteIcon.style.display = 'none';
                    }

                    deleteIcon.addEventListener("click", () => {
                        const { id } = data;
                        this.deleteConfig(id);
                    });
                }

                if (updateStatusActiveIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'autcom-module.settings.prioritati-cerere.update-status'
                        )
                    ) {
                        updateStatusActiveIcon.style.display = 'none';
                    }
                    updateStatusActiveIcon.addEventListener("click", () => {
                        const { id } = data;
                        this.changeStatusActive(id);
                    });
                }

                if (updateStatusPublicIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'autcom-module.settings.prioritati-cerere.update-status'
                        )
                    ) {
                        updateStatusPublicIcon.style.display = 'none';
                    }
                    updateStatusPublicIcon.addEventListener("click", () => {
                        const { id } = data;
                        this.changeStatusPublic(id);
                    });
                }

                return row;
            },
        };
    }

    changeStatusActive(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: "O să actualizați statusul înregistrării selectate!",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusActiveAction(id);
            }
        });
    }

    changeStatusActiveAction(id: number) {
        this.isLoading = true;
        this.cererePriorityService.changeStatusActive(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: "Înregistrare actualizată cu succes!",
                    icon: "success",
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: "error",
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusActiveAction(id);
                    }
                });
            }
        );
    }

    changeStatusPublic(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: "O să actualizați statusul înregistrării selectate!",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusPublicAction(id);
            }
        });
    }

    changeStatusPublicAction(id: number) {
        this.isLoading = true;
        this.cererePriorityService.changeStatusPublic(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: "Înregistrare actualizată cu succes!",
                    icon: "success",
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: "error",
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusPublicAction(id);
                    }
                });
            }
        );
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
        this.showCard = false;
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddCererePriorityComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: "Prioritate cerere adăugată cu succes.",
                    icon: "success",
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditCererePriorityComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: "Prioritate cerere actualizată cu succes.",
                    icon: "success",
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    deleteConfig(id: number) {
        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: helper.swalTextConfig.generalMessages.delete,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.cererePriorityService.deleteCererePriority(id).subscribe(() => {
                    this.rerenderDT();
                    Swal.fire({
                        title: this.helper.swalTextConfig.headers.deleted,
                        text: "Prioritate cerere ștearsă cu succes.",
                        icon: "success",
                        confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
                    });
                });
            }
        });
    }

    clearCache() {
        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: helper.swalTextConfig.generalMessages.cleanCache,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.cererePriorityService.clearCache().subscribe(() => {
                    this.rerenderDT();
                    Swal.fire({
                        title: helper.swalTextConfig.headers.deleted,
                        text: helper.swalTextConfig.generalMessages.cleanCacheSuccess,
                        icon: "success",
                        confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
                    });
                });
            }
        });
    }
}
